<template>
    <el-card class="mr20" shadow="never">
        <div slot="header" class="clearfix">
            <span class="card-title">标题</span>
            <span class="sub-title text-color-gray">支持最多5个标题，1-15个字符，必填项</span>
        </div>
        <el-form :model="formData" label-width="60px" label-position="left" @submit.native.prevent>
            <el-form-item  
                v-for="(item, index) in formData.titleList" 
                :label="`标题${index+1}`"
                :key="item.key"
                :prop="'titleList.' + index + '.title'"
                :rules="[
                    {required: true, message: '标题不能为空', trigger: 'blur'},
                    { validator: validateTitle, trigger: 'blur' }
                ]"
            >
                <el-input 
                    v-model="item.title"
                    placeholder="请输入" 
                    style="max-width: 400px"
                    maxlength="15"
                    show-word-limit
                /> 
                <i class="el-icon-delete title-icon" @click="handleDelTitle(item)"/>
            </el-form-item>
            <el-form-item>
                <el-button 
                    type="primary" plain icon="el-icon-plus"
                    @click="handleAddTitle"
                >添加</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
import { validEmoji } from '@/utils/validate';
const TITLE_TYPE = {
    MAX_LEN: 5,
    MIN_LEN: 1
}
export default {
    name: 'AppTitle',
    inject: [ 'aiLaunchGlobal' ],
    data() {
        const appId = this.aiLaunchGlobal.appId;
        const appTitleData = this.aiLaunchGlobal.appTitleData;
        const title_list = this.aiLaunchGlobal.tempPlatDdata.title_list;
        const defaultTitleList = appTitleData[appId] ? appTitleData[appId] : title_list;
        
        const validateTitle = (rule, value, callback)=> {
            const tip = '不可输入{}、空格与表情，不可超过15个字'
            if (validEmoji(value)) {
                callback(new Error(tip))
            }else if(/\{|\}|\s/.test(value)) {
                callback(new Error(tip))
            }else {
                callback()
            }
        }
        return {
            validateTitle,
            formData: { 
                titleList: defaultTitleList.map((title, i)=> {
                    return {
                        title,
                        key: Date.now() + i
                    }
                })
            }
        }
    },
    methods: {
        handleAddTitle() {
            if (this.formData.titleList.length>=TITLE_TYPE.MAX_LEN) {
                this.$message.error('最多拥有五个标题')
                return
            }
            this.formData.titleList.push({title:'', key: Date.now()})
        },
        handleDelTitle(row) {
            if (this.formData.titleList.length<=TITLE_TYPE.MIN_LEN) {
                this.$message.error('最少需要保留一个标题')
                return
            };
            const list = this.formData.titleList;
            list.splice(list.indexOf(row),1);
        }
    },
    watch: {
        'aiLaunchGlobal.appId'(n, o) {
            const appId = this.aiLaunchGlobal.appId;
            const appTitleData = this.aiLaunchGlobal.appTitleData;
            const title_list = this.aiLaunchGlobal.tempPlatDdata.title_list;
            const defaultTitleList = appTitleData[appId] ? appTitleData[appId] : title_list;
            this.formData.titleList = defaultTitleList.map((title, i)=> {
                return {
                    title,
                    key: Date.now() + i
                }
            })
        },
        'formData.titleList': {
            handler(n) {
                const appId = this.aiLaunchGlobal.appId;
                this.aiLaunchGlobal.updataTitleData(appId, n.map(v=>v.title))
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.card-title {
    font-size: 14px;
    font-weight: bold;
}
.sub-title {
    padding-left: 12px;
}
.title-icon {
    font-size: 18px;
    cursor: pointer;
    padding-left: 8px;
    color: red;
}
</style>